import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Btn } from "@/components/UI";
import { Eye, Pencil, CheckCircle2, FileText, Send, Mail, Trash2, XCircle, Download, Printer } from "lucide-react";
import { previewPdf, downloadPdf, printPdf } from "@/lib/pdfActions";
import { apiError } from "@/lib/customers";
import { LabelButtons } from "@/components/shipping/LabelButtons";

const notify = (msg) => window.alert(msg);

export function OrderActions({ so, caps, onChanged, compact = false, showDetail = true }) {
  const nav = useNavigate();
  const pdfPath = `/sales-orders/${so.id}/proforma.pdf`;
  const pdfName = `Proforma_${so.so_no}.pdf`;
  const editable = ["draft", "approved"].includes(so.status);
  const run = async (fn, okMsg) => {
    try { const r = await fn(); if (okMsg) notify(okMsg); onChanged?.(r); } catch (e) { notify(apiError(e, "İşlem başarısız")); }
  };
  const approve = () => run(async () => {
    const r = await api.post(`/sales-orders/${so.id}/approve`);
    const short = (r.stock_check?.items || []).filter((i) => i.shortage > 0);
    notify(short.length ? `Sipariş onaylandı.\n⚠ ${short.map((i) => `${i.product_name}: ${i.shortage} adet eksik`).join("\n⚠ ")}` : "Sipariş onaylandı, stok yeterli.");
    return r;
  });
  const cancel = () => {
    const reason = window.prompt(`${so.so_no} iptal edilsin mi? Açık rezervasyonlar serbest bırakılır.\nİptal sebebi (opsiyonel):`);
    if (reason === null) return;
    run(() => api.post(`/sales-orders/${so.id}/cancel`, { reason }));
  };
  const remove = () => {
    const extra = so.status === "approved" ? "\nOnaylı sipariş önce otomatik iptal edilir ve rezervasyonu serbest bırakılır." : "";
    if (!window.confirm(`${so.so_no} silinsin mi?${extra}\nSipariş Çöp Kutusu'na taşınır.`)) return;
    run(() => api.del(`/sales-orders/${so.id}`));
  };
  const sz = compact ? "sm" : undefined;
  const t = (k) => `so-${k}-${so.id}`;
  return (
    <div className="flex flex-wrap gap-1" onClick={(e) => e.stopPropagation()}>
      {showDetail && <Btn size={sz} variant="secondary" onClick={() => nav(`/sales-orders/${so.id}`)} data-testid={t("detail")}><Eye size={12} /> Detay</Btn>}
      {caps.edit && editable && <Btn size={sz} variant="secondary" onClick={() => nav(`/sales-orders/${so.id}/edit`)} data-testid={t("edit")}><Pencil size={12} /> Düzenle</Btn>}
      {caps.approve && so.status === "draft" && <Btn size={sz} onClick={approve} data-testid={t("approve")}><CheckCircle2 size={12} /> Onayla</Btn>}
      <Btn size={sz} variant="secondary" onClick={() => previewPdf(pdfPath, pdfName)} data-testid={t("pdf")}><FileText size={12} /> Proforma</Btn>
      {!compact && <Btn variant="secondary" onClick={() => downloadPdf(pdfPath, pdfName)} data-testid={t("pdf-download")}><Download size={12} /> İndir</Btn>}
      {!compact && <Btn variant="secondary" onClick={() => printPdf(pdfPath, pdfName)} data-testid={t("pdf-print")}><Printer size={12} /> Yazdır</Btn>}
      {caps.send && so.status !== "cancelled" && <Btn size={sz} variant="secondary" onClick={() => run(() => api.post(`/sales-orders/${so.id}/send-telegram`), "Proforma Telegram ile gönderildi.")} data-testid={t("telegram")}><Send size={12} /> Telegram</Btn>}
      {caps.send && so.status !== "cancelled" && <Btn size={sz} variant="secondary" onClick={() => run(() => api.post(`/sales-orders/${so.id}/send-email`), "Proforma e-posta ile gönderildi.")} data-testid={t("email")}><Mail size={12} /> E-posta</Btn>}
      {caps.cancel && editable && <Btn size={sz} variant="secondary" onClick={cancel} data-testid={t("cancel")}><XCircle size={12} /> İptal</Btn>}
      {so.status !== "cancelled" && <LabelButtons orderId={so.id} soNo={so.so_no} status={so.status} size={sz} testid="so-label" withPrint={!compact} />}
      {caps.delete && !["partial", "completed"].includes(so.status) && <Btn size={sz} variant="danger" onClick={remove} data-testid={t("delete")}><Trash2 size={12} /> Sil</Btn>}
    </div>
  );
}
